import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, finalize } from 'rxjs';

import { CompanySubscription } from '@shared/models';

import { BaseService } from '../base.service';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class CompanySubscriptionService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  edit(loader: string, dto: CompanySubscription): Observable<CompanySubscription> {
    this.loadersService.show(loader);
    return this.http
      .put<CompanySubscription>(this.baseUrl + '/subscriptions', dto)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getCompanySubscriptionByCompany(loader: string, id?: string): Observable<CompanySubscription> {
    this.loadersService.show(loader);
    return this.http
      .get<CompanySubscription>(`${this.baseUrl}/subscriptions/company/${id}`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getMyCompanySubscription(loader: string): Observable<CompanySubscription> {
    this.loadersService.show(loader);
    return this.http
      .get<CompanySubscription>(`${this.baseUrl}/subscriptions/company/my`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getStripePortalSession(loader: string): Observable<{ url: string }> {
    this.loadersService.show(loader);
    return this.http
      .get<{ url: string }>(`${this.baseUrl}/subscriptions/stripe/session`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  reactivateMyCompanySubscription(loader: string): Observable<CompanySubscription> {
    this.loadersService.show(loader);
    return this.http
      .post<CompanySubscription>(`${this.baseUrl}/subscriptions/company/my/reactivate`, null)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  reactivateCompanySubscription(loader: string, companyId: string): Observable<CompanySubscription> {
    this.loadersService.show(loader);
    return this.http
      .post<CompanySubscription>(`${this.baseUrl}/subscriptions/company/${companyId}/reactivate`, null)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  cancelCompanySubscription(loader: string, companyId: string): Observable<CompanySubscription> {
    this.loadersService.show(loader);
    return this.http
      .post<CompanySubscription>(`${this.baseUrl}/subscriptions/company/${companyId}/cancel`, null)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getCompanyStripePortalSession(loader: string, companyId: string): Observable<{ url: string }> {
    this.loadersService.show(loader);
    return this.http
      .get<{ url: string }>(`${this.baseUrl}/subscriptions/company/${companyId}/stripe/session`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }
}
